import "./FormShell.scss";
import FS_Home_Formulario_Fondo_Verde from "../../../assets/img/FS-Home-Formulario-Fondo-Verde.jpg";
import FS_LOGO_BLANCO from "../../../assets/img/FS-LOGO-BLANCO.svg";
import FS_HOME_COTIZACION_HOMBRE_IMAGEN from "../../../assets/img/FS-HOME-COTIZACION-HOMBRE-IMAGEN.png";
import FS_CONTACTO_TRES_PERFILES_IMAGEN from "../../../assets/img/FS-CONTACTO-TRES-PERFILES-IMAGEN.png";
import { Button } from "../../Atoms/Button/Button";
import homeContent from "../../Pages/Home/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content.js";

function FormShell({
	home,
	children,
	title,
	contact,
	g_evolution,
	whiteBg,
	oneSide,
}) {
	const {language} = useLanguageCtx();

	return (
		<div className={`formShell-backgrounds-grid`}>
			<div
				className={`formShell-shell-container ${g_evolution && "g-evolution"}`}
			>
				{oneSide && (
					<div className="formShell-shell one-side">
						<h1 className="t2 no-space mb-25">{title}</h1>
						{children}
					</div>
				)}
				{!oneSide && (
					<div className="formShell-shell ">
						<div className="formShell-left-side-container grid fullColumn">
							<div className="formShell-header-container">
								{home && (
									<h6 className="t5 c-yellow no-space yellow-line right-side">
										{homeContent[language].formYellowTitle}
									</h6>
								)}
								<h1 className="t2">{title}</h1>
							</div>
							<div
								className={`formShell-formik-container ${
									home ? "with-orange-text" : "without-orange-text"
								}`}
							>
								{children}
							</div>
						</div>
						<div className="formShell-right-side-container grid fullColumn">
							<div className="formShell-picture-container">
								<img
									src={FS_Home_Formulario_Fondo_Verde}
									alt="FS-HOME-COTIZACION-IMAGEN-NARANJA"
									className="all-width-height formShell-right-side-img"
								/>
							</div>
							{home && (
								<>
									<div className="formShell-person-picture-container">
										<img
											src={FS_HOME_COTIZACION_HOMBRE_IMAGEN}
											alt="Person"
											className="all-width-height aspect-ratio contain formShell-person-picture"
										/>
									</div>
									<div className="formShell-right-title-container">
										<h1 className="c-white t3">
											{homeContent[language].formRightText}
										</h1>
									</div>
								</>
							)}
							{contact && (
								<>
									<div className="formShell-contact-personas-img-container">
										<img
											src={FS_CONTACTO_TRES_PERFILES_IMAGEN}
											alt="Personas"
											className="all-width-height aspect-ratio contain"
										/>
									</div>
									<div className="formShell-contact-text-container">
										<h4 className="t4 c-white center-text">
											{content[language].contact_title}
										</h4>
										<p className="body-16 c-white center-text">
											{content[language].contact_text}
										</p>
									</div>
									{/* <div className="formShell-contact-first-button all-columns">
										<Button
											type="button white outline"
											content={content[language].contact_button_1}
										/>
									</div> */}
									<div className="formShell-contact-first-button all-columns">
										<Button
											type="button white outline"
											content={content[language].contact_button_2}
											buttonRoute="/recursos/soporte"
										/>
									</div>
								</>
							)}
							<div className="formShell-fs-logo-container">
								<img
									src={FS_LOGO_BLANCO}
									alt="FS_LOGO_BLANCO"
									className="all-width-height"
								/>
							</div>
						</div>
					</div>
				)}
			</div>
			<div className={`formShell-blue-bg ${whiteBg && "whiteBg"}`}></div>
		</div>
	);
}

export default FormShell;
